// Langue de l'admin. Le choix est mémorisé dans le navigateur et appliqué au chargement de la page :
// changer de langue recharge simplement la page (pas besoin de tout re-rendre à la volée).
import fr from './lang/fr.json';
import en from './lang/en.json';

export const LANGUAGES = [
  { code: 'fr', label: 'Français', short: 'FR' },
  { code: 'en', label: 'English', short: 'EN' },
];

const catalogs = { fr, en };
const STORAGE_KEY = 'tsk-lang';

export function getLocale() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && catalogs[stored]) return stored;
  } catch (e) { /* localStorage unavailable */ }
  return 'fr';
}

export function setLocale(code) {
  if (!catalogs[code]) return;
  try { window.localStorage.setItem(STORAGE_KEY, code); } catch (e) { /* ignore */ }
  window.location.reload();
}

export const locale = getLocale();
export const messages = { ...fr, ...catalogs[locale] }; // repli sur le français si une clé manque

if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', locale);

const interpolate = (text, values) => (
  values ? text.replace(/\{(\w+)\}/g, (m, name) => (values[name] !== undefined ? values[name] : m)) : text
);

// Texte traduit : t('ui.save', { name: 'x' }). Retourne la clé si elle est inconnue.
export function t(id, values) {
  const text = messages[id];
  return interpolate(text !== undefined ? text : id, values);
}

// Pluriel : tn('ui.screens', 3) lit ui.screens_one / ui.screens_other ({count} est ajouté aux valeurs).
export function tn(id, count, values) {
  const one = locale === 'fr' ? count < 2 : count === 1;
  return t(`${id}_${one ? 'one' : 'other'}`, { count, ...values });
}

export const dateLocale = locale === 'fr' ? 'fr-FR' : 'en-GB';
